import { PlusOutlined } from '@ant-design/icons'
import { Button, Card, Flex } from 'antd'
import { PropsWithChildren } from 'react'

import { Permissions } from 'src/api/requests'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = PropsWithChildren<{
  onToggle: () => void
}>

export const ContactsLayout = ({ children, onToggle }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { hasPermission } = useUser()

  return (
    <Card title={t('consultations.contacts')}>
      <Flex vertical gap={16} key="list">
        {children}

        {hasPermission(
          Permissions.TREATMENT_CONSULTATION_CREATE_POTENTIAL_CONTACTS_INSTITUTION
        ) && (
          <Button
            icon={<PlusOutlined />}
            className={styles.button}
            onClick={onToggle}
          >
            {t('consultations.contacts_add')}
          </Button>
        )}
      </Flex>
    </Card>
  )
}
